import PropTypes from 'prop-types';
import React, { Component } from 'react';

export interface InjectedProps {
    problemBlockPlateStyles: Record<string, object>;
}

export function withProblemBlockPlate<T extends InjectedProps>(WrappedComponent: React.ComponentType<T>) {
    return class WithProblemBlockPlate extends Component<T> {
        static contextTypes = {
            problemPlate: PropTypes.object,
        };

        context!: React.ContextType<React.Context<{ problemPlate: object }>>;

        render() {
            const { problemPlate } = this.context;

            return <WrappedComponent {...this.props} problemBlockPlateStyles={problemPlate} />;
        }
    } as React.ComponentType<Omit<T, keyof InjectedProps>>;
}
